import { MODALS } from '_constants';
import { LOGIN } from '../constants/login.constants';
import { INITIAL_APP_STATE } from '../constants/common.constants';
import { customModalActions } from 'actions';

export const modals = (state = {}, action) => {
  let newState = { ...state };
  // This kind of an update to a modal renders the modal un interactive.
  switch (action.type) {
    case MODALS.UPDATE_CUSTOM_MODEL:
      newState.customModal.show = action.show; // Boolean
      newState.customModal.title = action.title;
      newState.customModal.body = action.body;
      newState.customModal.onOk = action.onOk;
      newState.customModal.onCancel = action.onCancel;
      newState.customModal.hideModal = action.hideModal || customModalActions.hideCustomModal;
      if (typeof (action.showCloseButton) === 'boolean') { newState.customModal.showCloseButton = action.showCloseButton; }
      if (typeof (action.size) === 'string') { newState.customModal.size = action.size; }
      if (typeof (action.okLabel) === 'string') { newState.customModal.okLabel = action.okLabel; }
      if (typeof (action.cancelLabel) === 'string') { newState.customModal.cancelLabel = action.cancelLabel; }
      if (typeof (action.closeOnOk) === 'boolean') { newState.customModal.closeOnOk = action.closeOnOk; }
      if (typeof (action.dialogClassName) === 'string') { newState.customModal.dialogClassName = action.dialogClassName; } else { newState.customModal.dialogClassName = 'custom-modal'; }
      if (typeof (action.okBtnClassVal) === 'string') { newState.customModal.okBtnClassVal = action.okBtnClassVal; }
      break;
    case MODALS.UPDATE_CUSTOM_MODEL_VISIBILITY:
      newState.customModal.show = action.show;
      break;
    case LOGIN.LOGOUT:
      newState = INITIAL_APP_STATE.modals;
      break;
    default:
      break;
  }
  return newState;
};
